import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useMain,
  useMaincategory,
  useTeamsPagenation,
} from "../../actions/homeActions";
export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allcategories, setAllcategories] = useState(true);
  const [seteledcategories, setSeteledcategories] = useState(false);
  const [jobHasMorePages, setNewsHasMorePages] = useState(false);
  const [additionalTeams, setAdditionalTeams] = useState([]);
  const [allTeamsCurrentPage, setAllTeamsCurrentPage] = useState(1);
  const [categoriesTtypesNewsId, setCategoriesTtypesNewsId] = useState(null);
  const { data: TheATeamData, isLoading: newsDataisLoading } =
    useTeamsPagenation(allTeamsCurrentPage);
  const {
    data: CategoriesTypesTeams,
    isError,
    error,
  } = useMaincategory("teams");
  const { data: singleCatTeamData, isLoading } = useMain(
    categoriesTtypesNewsId
  );
  const handleButtonClick = (id) => {
    setAllcategories(false);
    setSeteledcategories(true);
    setCategoriesTtypesNewsId(id);
  };
  useEffect(() => {
    if (TheATeamData) {
      setNewsHasMorePages(TheATeamData?.has_more_pages);
      setAdditionalTeams((prevNews) => {
        const newNews = TheATeamData?.teams || [];
        const uniqueJobs = [...prevNews, ...newNews].reduce((acc, news) => {
          if (!acc.some((j) => j.id === news.id)) {
            acc.push(news);
          }
          return acc;
        }, []);
        return uniqueJobs;
      });
    }
  }, [TheATeamData]);
  const handleTeamId = (id, TheATeamColorsData) => {
    dispatch({
      type: "UPDATE_TEAM_DATA",
      payload: { teamData: TheATeamColorsData },
    });
    navigate(`/single-team/${id}`);
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading teams: {error.message}</p>
      </div>
    );
  }
  return {
    setAllcategories,
    handleButtonClick,
    handleTeamId,
    setSeteledcategories,
    allcategories,
    categoriesTtypesNewsId,
    TheATeamData,
    CategoriesTypesTeams,
    additionalTeams,
    newsDataisLoading,
    jobHasMorePages,
    setAllTeamsCurrentPage,
    seteledcategories,
    isLoading,
    singleCatTeamData,
  };
};
